import React from 'react'

const Header: React.FC = () => {
  return (
    <header className="bg-mover-darkest bg-opacity-90 backdrop-blur-md shadow-lg py-4">
      <div className="container mx-auto px-4 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
        <a href="https://www.movermarketing.ai/?utm_source=online&utm_medium=seoaudit&utm_campaign=seoaudit&utm_id=seoaudit" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex justify-center">
          <img 
            src="https://cdn.prod.website-files.com/655eab7c6672c96cce7b73d4/655eaf0c2299eef85493f45e_Mover-Marketing-AI-DarkSVG.svg" 
            alt="Mover Marketing AI Logo" 
            className="h-10 w-auto"
          />
        </a>
        <a 
          href="https://www.movermarketing.ai/?utm_source=online&utm_medium=seoaudit&utm_campaign=seoaudit&utm_id=seoaudit" 
          target="_blank" 
          rel="noopener noreferrer"
          className="hidden sm:inline-block text-mover-light hover:text-mover-cyan transition-colors duration-300 text-center"
        >
          powered by Mover Marketing AI
        </a>
        <a 
          href="https://www.movermarketing.ai/book-a-call?utm_source=online&utm_medium=seoaudit&utm_campaign=seoaudit&utm_id=seoaudit" 
          target="_blank" 
          rel="noopener noreferrer"
          className="btn-primary rounded-lg px-4 py-2 w-full sm:w-auto text-center"
        >
          Get a Free SEO Consultation
        </a>
      </div>
    </header>
  )
}

export default Header